import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { WallpaperService } from '../../services/wallpaper.service';
import { DataLayerService } from '../../services/datalayer.service';
import { categorySlugById } from '../../models/constants';

@Component({
  selector: 'app-wall-art',
  templateUrl: './wall-art.component.html',
})
export class WallArtComponent implements OnInit, OnDestroy {

  slides: any[] = [
    {
      image: 'https://storage.googleapis.com/static-mahattaart-online/banner/SM_Wall-Art-Banner_03.webp',
      mobile_image: 'https://storage.googleapis.com/static-mahattaart-online/banner/Phone-Banner-02%20(1).webp',
      title: 'Wall Art',
      published: 1,
      button_link: '/art-ready'
    }
  ];
  widgets: any[] = [];
  heading: any[] = [];
  topCategories: any[] = [];
  banners: any[] = [];
  brands: any[] = [];
  art_for_business: any[] = [];

  // From /api/unauth/setting → home
  shopInspired: any[] = [];
  home_heading: any[] = [];

  // From /api/unauth/on_sale
  featuredProducts: any[] = [];

  // From /api/unauth/requirement
  requirements = [
    {
      title: 'Wall Decor Consultation',
      image: 'icons/icon1.png'
    },
    {
      title: 'Customize your way',
      image: 'icons/icon2.png'
    },
    {
      title: 'Licensed Artwork',
      image: 'icons/icon3.png'
    },
    {
      title: '200+ Framing options',
      image: 'icons/icon4.png'
    },
    {
      title: 'Affordable price',
      image: 'icons/icon5.png'
    },
    {
      title: 'Top Quality',
      image: 'icons/icon6.png'
    },
    {
      title: 'Customer Support',
      image: 'icons/icon7.png'
    },
    {
      title: 'Easy Return & Exchange',
      image: 'icons/icon8.png'
    },
    {
      title: 'Secured Checkout',
      image: 'icons/icon9.png'
    },
    {
      title: 'Worldwide shipping',
      image: 'icons/icon10.png'
    }
  ];
  // Sub-nav
  shopByCategoryOpen = false;
  categories: any[] = [];

  // Carousels
  @ViewChild('categoryCarousel') categoryCarousel!: ElementRef<HTMLElement>;
  @ViewChild('discoverCarousel') discoverCarousel!: ElementRef<HTMLElement>;

  // Slideshow
  currentSlide = 0;
  private slideInterval: any;

  // Search form
  form!: FormGroup;

  wishlistIds = new Set<string>();
  private sub = new Subscription();

  // ── Wall art product types (dynamic, static fallback) ───────────────────
  productTypes: any[] = [
    { label: 'Explore By Painting',      image: '../../../assets/images/wall-art/Painting.jpg',     art_type_id: 1, desc: "Elevate Your Space With Our Art Collection" },
    { label: 'Explore By Illustration',  image: '../../../assets/images/wall-art/Illustrtion.jpg',  art_type_id: 4, desc: "Elevate Your Space With Our Art Collection" },
    { label: 'Explore By Poster',        image: '../../../assets/images/wall-art/poster.jpg',        art_type_id: 3, desc: "Elevate Your Space With Our Art Collection" },
    { label: 'Explore By Photography',   image: '../../../assets/images/wall-art/photography.jpg',  art_type_id: 2, desc: "Elevate Your Space With Our Art Collection" },
  ];

  // ── How-to-buy steps (dynamic, static fallback) ──────────────────────────
  steps: any[] = [
    { label: 'Select Art', desc: 'Choose art from the list of exclusive art collections', image: 'https://storage.googleapis.com/mahattaart-wallpaper/modern.jpg' },
    { label: 'Customize Art your Way', desc: 'Personalize art as per your space decor, from product, size & frame to mount', image: 'https://storage.googleapis.com/mahattaart-wallpaper/scenic.jpg' },
    { label: 'Receive at Door-step', desc: 'Get within your desired time from 4–5 days to overnight', image: 'https://storage.googleapis.com/mahattaart-wallpaper/ABSTRACT%20%26%20GEOMETRIC.png' },
  ];

  // ── Explore By Art Search (dynamic, static fallback) ────────────────────
  artSearchImage = 'https://storage.googleapis.com/mahattaart-wallpaper/Striking%20Bedroom%20Wallpapers.jpg';
  artSearchTitle = 'Explore By Art Search';
  artSearchCategories: any[] = [
    { label: 'Artist', type: 'space', value: 'Artist' },
    { label: 'Art Style', type: 'space', value: 'Art Style' },
    { label: 'Subjects', type: 'space', value: 'Subjects' },
    { label: 'Places', type: 'space', value: 'Places' },
    { label: 'Museum Collection', type: 'space', value: 'Museum Collection' },
  ];

  // ── Explore By Art Space (dynamic, static fallback) ─────────────────────
  artSpaceImage = 'https://storage.googleapis.com/mahattaart-wallpaper/Office.jpg';
  artSpaceTitle = 'Explore By Art Space';
  artSpaceCategories: any[] = [
    { label: 'Rooms', type: 'space', value: 'Living Room' },
    { label: 'Theme', type: 'mood', value: 'Modern' },
  ];

  // ── Explore Categories (dynamic, static fallback) ────────────────────────
  exploreCategories: any[] = [
    { label: 'Paintings', type: 'mood', value: 'Artistic', image: 'https://storage.googleapis.com/mahattaart-wallpaper/ART.png' },
    { label: 'Photography', type: 'mood', value: 'Serene', image: 'https://storage.googleapis.com/mahattaart-wallpaper/photographic.jpg' },
    { label: 'Posters', type: 'mood', value: 'Modern', image: 'https://storage.googleapis.com/mahattaart-wallpaper/modern.jpg' },
    { label: 'Illustration', type: 'mood', value: 'Whimsical', image: 'https://storage.googleapis.com/mahattaart-wallpaper/ANIMALS.png' },
  ];

  @HostListener('document:click', ['$event'])
  onDocumentClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.closest('.shop-by-category-wrap')) {
      this.shopByCategoryOpen = false;
    }
  }

  constructor(
    public router: Router,
    public state: AppStateService,
    private wallpaperService: WallpaperService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private dataLayer: DataLayerService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({ searchText: ['', Validators.required] });
    this.sub.add(this.state.wishlistIds$.subscribe(ids => this.wishlistIds = ids));
    this.loadPageData();
    // this.loadCategories();
    this.getThemes();
  }

  public getThemes() {
    this.wallpaperService.getWallArtCategories('themes', '').subscribe(res => {
      this.topCategories = res;
      console.log("wallaart themes", this.topCategories);
      // console.log(this.wall_art_themes);
      // this.themes = this.themes.filter(item => this.wall_art_themes.filter(item1 => item1 == item.id).length > 0);

    });
  }

  getImageUrl(path: string): string {
    return `https://storage.googleapis.com/static-mahatta-com/${path}`;
  }


  // private loadCategories() {
  //   this.wallpaperService.getCategories().subscribe({
  //     next: (res: any) => { this.categories = res?.data ?? res ?? []; },
  //     error: () => { }
  //   });
  // }

  navigateToSubCategory(cat: any) {
    const slug = cat.slug || String(cat.id);
    this.shopByCategoryOpen = false;
    this.router.navigate(['/wallpaper/category', slug], {
      queryParams: { sortby: 'id', sortdir: 'desc', category: categorySlugById(cat.id) || cat.id }
    });
  }

  private loadPageData() {
    forkJoin({
      meta: this.wallpaperService.getWallArtMeta().pipe(catchError(() => of(null))),
      setting: this.wallpaperService.getSetting().pipe(catchError(() => of(null))),
      reqs: this.wallpaperService.getRequirements().pipe(catchError(() => of(null))),
      featured: this.wallpaperService.getWallArtFeaturedProducts().pipe(catchError(() => of(null))),
    }).subscribe(({ meta, setting, reqs, featured }) => {
      // ── Meta ──────────────────────────────────────────────────────────────
      const d = meta?.data?.wall_art ?? meta?.data?.['_wall-art'] ?? meta?.data ?? null;
      if (d) {
        this.widgets = d.widgets || [];
        this.heading = d.heading || [];
        // this.topCategories   = d.top_categories      || [];
        this.banners = d.featured_collection || [];
        this.brands = d.claude_monet_collection || [];
        this.art_for_business = d.art_for_business || [];

        // Dynamic overrides — product types
        // if (d.product_types?.length) this.productTypes = d.product_types;
        // else if (d.wall_art_products?.length) this.productTypes = d.wall_art_products;

        // Dynamic overrides — how to buy / steps
        if (d.how_to_buy?.length) this.steps = d.how_to_buy;
        else if (d.steps?.length) this.steps = d.steps;
        else if (d.buy_steps?.length) this.steps = d.buy_steps;

        // Dynamic overrides — explore categories
        if (d.explore_categories?.length) this.exploreCategories = d.explore_categories;
        else if (d.art_categories?.length) this.exploreCategories = d.art_categories;

        // Dynamic overrides — art search section
        const artSearch = d.art_search_section || d.explore_by_search || null;
        if (artSearch) {
          if (artSearch.image) this.artSearchImage = artSearch.image;
          if (artSearch.title) this.artSearchTitle = artSearch.title;
          if (artSearch.categories?.length) this.artSearchCategories = artSearch.categories;
        }

        // Dynamic overrides — art space section
        const artSpace = d.art_space_section || d.explore_by_space || null;
        if (artSpace) {
          if (artSpace.image) this.artSpaceImage = artSpace.image;
          if (artSpace.title) this.artSpaceTitle = artSpace.title;
          if (artSpace.categories?.length) this.artSpaceCategories = artSpace.categories;
        }

        this.startSlideshow();
      }

      // ── Setting fallbacks ─────────────────────────────────────────────────
      const wa = setting?.data?.wall_art;
      if (wa) {
        // slides are static (defined in component)
        if (!this.widgets.length) this.widgets = wa.widgets || [];
        if (!this.heading.length) this.heading = wa.heading || [];
        if (!this.topCategories.length) this.topCategories = wa.top_categories || [];
        if (!this.banners.length) this.banners = wa.featured_collection || [];
        if (!this.brands.length) this.brands = wa.claude_monet_collection || [];
        if (!this.art_for_business.length) this.art_for_business = wa.art_for_business || [];

        // Setting fallbacks for dynamic sections
        // if (wa.product_types?.length && this.productTypes.length <= 3)
        //   this.productTypes = wa.product_types;
        if (wa.how_to_buy?.length && this.steps.length <= 3)
          this.steps = wa.how_to_buy;
        if (wa.explore_categories?.length && this.exploreCategories.length <= 4)
          this.exploreCategories = wa.explore_categories;

        const waArtSearch = wa.art_search_section || wa.explore_by_search;
        if (waArtSearch && this.artSearchCategories.length <= 5) {
          if (waArtSearch.image) this.artSearchImage = waArtSearch.image;
          if (waArtSearch.title) this.artSearchTitle = waArtSearch.title;
          if (waArtSearch.categories?.length) this.artSearchCategories = waArtSearch.categories;
        }

        const waArtSpace = wa.art_space_section || wa.explore_by_space;
        if (waArtSpace && this.artSpaceCategories.length <= 2) {
          if (waArtSpace.image) this.artSpaceImage = waArtSpace.image;
          if (waArtSpace.title) this.artSpaceTitle = waArtSpace.title;
          if (waArtSpace.categories?.length) this.artSpaceCategories = waArtSpace.categories;
        }
      }

      // Home section (shop inspired)
      const home = setting?.data?.home;
      if (home) {
        this.shopInspired = home.shop_inspired || [];
        this.home_heading = home.heading || [];
      }

      // ── Requirements ──────────────────────────────────────────────────────
      const reqData = reqs?.data ?? reqs;
      // this.requirements = Array.isArray(reqData) ? reqData : [];

      // ── Featured products ─────────────────────────────────────────────────
      const prodData = featured?.data ?? featured?.results ?? [];
      this.featuredProducts = Array.isArray(prodData) ? prodData : [];

      this.cdr.detectChanges();

    });
  }

  private startSlideshow() {
    if (this.slides.length <= 1) return;
    clearInterval(this.slideInterval);
    this.slideInterval = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      this.cdr.detectChanges();
    }, 4000);
  }

  // ── Heading helpers ───────────────────────────────────────────────────────
  getHeading(index: number, fallback: string): string {
    return this.heading[index]?.title || fallback;
  }

  prevSlide() { this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length; }
  nextSlide() { this.currentSlide = (this.currentSlide + 1) % this.slides.length; }

  scrollCategories(direction: 'left' | 'right') {
    const el = this.categoryCarousel?.nativeElement;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.8;
    el.scrollBy({ left: direction === 'right' ? scrollAmount : -scrollAmount, behavior: 'smooth' });
  }

  scrollDiscover(direction: 'left' | 'right') {
    const el = this.discoverCarousel?.nativeElement;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.8;
    el.scrollBy({ left: direction === 'right' ? scrollAmount : -scrollAmount, behavior: 'smooth' });
  }

  onSearch(e: Event) {
    e.preventDefault();
    const q = this.form.value.searchText?.trim();
    if (q) {
      this.state.updateContext({ search_query: q, selected_space: null, selected_space_id: null, selected_category: null, selected_category_id: null, selected_mood: null, entry_point: null });
      this.router.navigate(['/listing']);
    }
  }

  navigateToProduct(product: any) {
    const slug = product?.title_slug || product?.slug || product?.caption;
    if (slug) {
      this.router.navigate(['/featured-art', slug]);
    } else if (product?.id) {
      this.router.navigate(['/featured-art', product.id]);
    }
  }

  toggleWishlist(product: any, e: Event) {
    e.stopPropagation();
    if (!product?.id) return;
    this.state.toggleWishlist(String(product.id), {
      id: String(product.id),
      name: product.name,
      image: product.list_thumbnail || product.image,
      price: product.price,
      wallpaper_type: product.wallpaper_type,
      wallpaper_id: product.wallpaper_id,
      slug: product.slug
    });
  }

  isWishlisted(product: any): boolean {
    return this.wishlistIds.has(String(product?.id));
  }

  navigateToCategory(cat: any) {
    const link = cat?.button_link || cat?.link;
    if (link) { this.router.navigateByUrl(link); return; }
    const slug = cat?.slug || cat?.title?.toLowerCase().replace(/\s+/g, '-') || String(cat?.id || '');
    if (slug) this.router.navigate(['/wall-art/art-by-search/themes', slug]);
    else this.router.navigate(['/wall-art']);
  }

  navigateToMood(mood: string) {
    this.state.updateContext({ selected_mood: mood, selected_space: null, selected_space_id: null, selected_category: null, selected_category_id: null, entry_point: null });
    this.router.navigate(['/listing']);
  }

  navigateBySpace(space: string) {
    this.state.updateContext({ selected_space: space, selected_space_id: null, entry_point: 'space', search_query: null });
    this.router.navigate(['/listing']);
  }

  navigateToArtReady(artTypeId?: number | string) {
    if (artTypeId) this.router.navigate(['/art-ready'], { queryParams: { art_type: artTypeId } });
    else this.router.navigate(['/art-ready']);
  }

  // Generic navigator for dynamic category/space/mood items
  navigateByCategory(cat: any) {
    const link = cat?.link || cat?.button_link;
    if (link) { this.router.navigateByUrl(link); return; }
    if (cat?.type === 'mood') { this.navigateToMood(cat.value || cat.mood); return; }
    if (cat?.type === 'space' || cat?.space) { this.navigateBySpace(cat.value || cat.space); return; }
    if (cat?.type === 'art_ready') { this.navigateToArtReady(cat.value); return; }
    if (cat?.title_slug) { this.router.navigate(['/featured-art', cat.title_slug]); return; }
    if (cat?.type === 'category' || cat?.slug) { this.navigateToCategory(cat); return; }
  }

  navigateToCustomDesign() { this.router.navigate(['/custom-design']); }
  navigateToCustomUpload() { this.router.navigate(['/custom-upload']); }

  getProductImage(p: any): string {
    return p?.list_thumbnail || p?.on_sale_image || p?.sale_image
      || p?.featured_image || p?.thumbnail_url || p?.thumbnail
      || p?.image || p?.image_url || p?.cover_image
      || p?.wallpaper?.list_thumbnail || p?.wallpaper?.thumbnail || '';
  }

  getProductHover(p: any): string {
    return p?.hover_thumbnail || p?.hover_image || this.getProductImage(p);
  }

  getProductName(p: any): string {
    return p?.name || p?.title || p?.caption || (p?.slug || '').replace(/_/g, ' ') || 'Wall Art';
  }

  getProductPrice(p: any): number {
    return p?.selling_price || p?.price || p?.sale_price || p?.discount_price || 0;
  }

  getProductMrp(p: any): number {
    return p?.mrp || p?.original_price || p?.regular_price || 0;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    clearInterval(this.slideInterval);
  }
}
